import { UserRole } from 'lib_ts/enums/auth.enums';
import { SessionMode } from 'lib_ts/interfaces/i-auth-token';

/** email domain that identifies internal Trajekt staff */
export const TRAJEKT_STAFF_EMAIL_DOMAIN = '@trajektsports.com';

/**
 * The Platform Console is restricted to internal Trajekt staff: super admins
 * on a @trajektsports.com email. Impersonation sessions are explicitly blocked.
 *
 * This is a UX guard only; access is authoritatively enforced server-side by
 * the `checkIsTrajektStaff` middleware.
 *
 * Kept dependency-light (enums only) so it can be unit-tested without importing
 * the auth store / i18n graph.
 */
export const isPlatformConsoleUser = (user: {
  role?: UserRole;
  mode?: SessionMode;
  email?: string;
}): boolean => {
  return (
    user.role === UserRole.admin &&
    user.mode !== SessionMode.Impostor &&
    (user.email ?? '').toLowerCase().endsWith(TRAJEKT_STAFF_EMAIL_DOMAIN)
  );
};
